import type {
  GetIdsFromSnapshot,
  ReplaceIdsFromSnapshot,
} from '../interactivityActionSnapshotMetadata';
import { InteractivityActionTypeValue } from '../InteractivityActionTypeValue';
import type { GoToSlideInteractivityActionSnapshotOut } from './GoToSlideInteractivityAction';

const replaceSlideIdsFromSnapshot: ReplaceIdsFromSnapshot<
  GoToSlideInteractivityActionSnapshotOut
> = (snapshot, replaceId) => {
  if (snapshot.target && 'slideId' in snapshot.target && snapshot.target.slideId) {
    snapshot.target.slideId = replaceId(snapshot.target.slideId);
  }
};

const getSlideIdsFromSnapshot: GetIdsFromSnapshot<
  GoToSlideInteractivityActionSnapshotOut
> = snapshot =>
  snapshot.target && 'slideId' in snapshot.target && snapshot.target.slideId
    ? [snapshot.target.slideId]
    : [];

export const goToSlideInteractivityActionSnapshotMetadata = {
  typeId: InteractivityActionTypeValue.GoToSlide,
  replaceSlideIdsFromSnapshot,
  getSlideIdsFromSnapshot,
};
